import { render, staticRenderFns } from "./recPop.vue?vue&type=template&id=30c65ee2&scoped=true"
import script from "./recPop.vue?vue&type=script&lang=js"
export * from "./recPop.vue?vue&type=script&lang=js"
import style0 from "./recPop.vue?vue&type=style&index=0&id=30c65ee2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30c65ee2",
  null
  
)

export default component.exports